<template>
    <div id="app">
        <app-banner />
        <color-currents-banner />

        <main id="main" role="main" v-if="!isFetching">
            <transition name="fade" mode="out-in">
                <router-view />
            </transition>
        </main>

        <app-loading v-else />

        <app-tail />

        <template>
            <vue-headful :title="documentTitle" />
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'

import AppBanner from '@/components/global/Banner'
import ColorCurrentsBanner from '@/components/global/ColorCurrentsBanner'
import AppTail from '@/components/global/Tail'
import AppLoading from '@/components/Loading'

export default {
    name: 'App',
    components: {
        AppBanner,
        ColorCurrentsBanner,
        AppLoading,
        AppTail
    },
    computed: mapGetters(['isFetching', 'documentTitle']),
    methods: {},
	// async/await doesnt work here
    async created() {
        // Load font CSS dynamically to handle CORS in dev and production
        const fontCssUrl = process.env.NODE_ENV === 'development'
            ? '/app/themes/marsh-furniture/custom-font/marsh-brand-font.css' // Uses proxy in dev
            : 'https://www.marshcabinets.com/app/themes/marsh-furniture/custom-font/marsh-brand-font.css' // Direct in production
        
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = fontCssUrl
        document.head.appendChild(link)
        
        await store.dispatch('fetchAll')
            .then(() => {
				window.currentCabinet = store.getters.selectedDoor
					? store.getters.selectedDoor.title
					: 'grid'
            })
    },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:100,200,300,400,500,600,700&display=swap');
// Font CSS is loaded dynamically in created() hook to handle CORS
@import '~tippy.js/themes/light.css';
@import '../assets/css/print';

@tailwind base;
@tailwind utilities;
@tailwind components;

html {
    //@apply bg-green;
    @apply antialiased;

    &.modal-open body { overflow: hidden; }
}
// outside of app, can't do body
#app, .modal, .tippy-popper {
    @apply font-body;
}
main {
    @apply bg-white pb-10;
}
.container {
    @apply mx-auto px-4 w-full;
    max-width: theme('screens.xl');
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .05s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
